import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { buttonFocusStyle } from '../buttons/common.styles';
import { InlineLabelPlacement } from '../forms';
import { IconButtonSize } from './types';

const buttonSizes = {
  normal: 40,
  small: 32,
  xsmall: 24,
  xxsmall: 16,
};

type IconButtonStyleProps = {
  size: IconButtonSize;
  color: 'default' | 'light';
  showLabelAlways?: boolean;
  labelPlacement?: InlineLabelPlacement;
  destructive?: boolean;
};

const styles = ({ size, color, labelPlacement, showLabelAlways, destructive }: IconButtonStyleProps) => [
  css`
    min-width: ${buttonSizes[size]}px;
    padding: ${theme.spacing(1)};
    height: ${buttonSizes[size]}px;
    width: ${showLabelAlways ? 'auto' : `${buttonSizes[size]}px`};
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: ${theme.borderRadius.small};
    display: flex;
    flex-direction: ${labelPlacement === 'right' ? 'row' : 'row-reverse'};
    gap: ${theme.spacing(1)};
    align-items: center;
    justify-content: center;
    transition: background-color 250ms ease-in-out;
    font-size: ${size === 'normal' ? theme.fontSize(16) : theme.fontSize(14)};
    color: ${destructive ? theme.colors.critical50 : theme.colors.neutral80};
    :hover {
      color: ${color === 'light' && theme.colors.neutral80};
    }
    ${destructive &&
    `
      svg {
        fill: ${theme.colors.critical50};
      }
    `};
    :hover:not(&[aria-disabled='true']),
    :focus {
      background: ${theme.colors.neutral5};
      transition: fill 250ms ease-in-out;
      svg {
        fill: ${color === 'light' && theme.colors.neutral80};
        :focus::before {
          width: calc(100% + ${theme.spacing(1)});
          height: calc(100% + ${theme.spacing(1)});
        }
      }
    }

    &[aria-disabled='true'] {
      cursor: default;
      color: ${theme.colors.neutral20};
      svg {
        fill: ${theme.colors.neutral20};
      }
    }
  `,
  buttonFocusStyle({
    borderRadius: theme.borderRadius.small,
    focusRingColor: theme.colors.primary50,
  }),
  showLabelAlways &&
    css`
      border-radius: 4px;
      ::before {
        border-radius: 4px;
      }
    `,
];

export const IconButtonStyles = {
  button: (iconButtonStylesProps: IconButtonStyleProps) => styles(iconButtonStylesProps),
};
